// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 28px;
}

tr.topMenu td {
  overflow: hidden;
  margin: 0;
  padding: 0px 10px;
  width: auto;
  height: 30px;
  border: 1px solid transparent;
  border-right: 1px solid rgb(230, 230, 230);
  cursor: pointer;
}

tr.topMenu td {
  height: 32px;
}

.noRightBorder {
  border-right: none;
}

#typeMenu {
  position: relative;
  top: 13px;
}

.clickMode {
  background-color: #EDF2F5;
}

#typeMenu div {
  padding: 0 3px;
}

#typeMenu div div {
  margin: auto;
  text-align: center;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.typeSelected {
  border-bottom: 5px solid #007566;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  margin: 27px -11px;
  border: 1px solid #EDF2F5;
  background-color: white;
  min-width: 160px;
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {
  background-color: #3e8e41;
}

ngx-loading ::ng-deep div div.spinner-three-bounce {
  position: fixed;
  right: 21%;
  z-index: 999;
}

ng-sidebar-container ::ng-deep ng-sidebar ::ng-deep aside {
  z-index: 130 !important;
}

ng-sidebar-container ::ng-deep ng-sidebar ::ng-deep #useMpoSatellite {
  z-index: 0 !important;
  position: relative;
}

::ng-deep .dropdown-menu {
  min-width: 180px;
}

::ng-deep .dropdown-item {
  display: block;
  padding-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/jobs/components/web/jobs-list/jobs-list.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;AACJ;;AAEA;EACI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,0CAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,WAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gCAAA;AACJ;;AAEA,kEAAA;AACA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;AACJ;;AAEA,8BAAA;AACA;EACI,kBAAA;EACA,qBAAA;EACA,cAAA;AACJ;;AAEA,oCAAA;AACA;EACI,cAAA;AACJ;;AAEA,0FAAA;AACA;EACI,yBAAA;AACJ;;AAEA;EACI,eAAA;EACA,UAAA;EACA,YAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAQA;EACI,qBAAA;EACA,kBAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,cAAA;EACA,iBAAA;AALJ","sourcesContent":["h1 {\n    font-size: 28px;\n}\n\ntr.topMenu td {\n    overflow: hidden;\n    margin: 0;\n    padding: 0px 10px;\n    width: auto;\n    height: 30px;\n    border: 1px solid transparent;\n    border-right: 1px solid rgb(230,230,230);\n    cursor: pointer;\n}\n\ntr.topMenu td {\n    height: 32px;\n}\n\n.noRightBorder {\n    border-right: none;\n}\n\n#typeMenu {\n    position: relative;\n    top: 13px\n}\n\n.clickMode {\n    background-color: #EDF2F5;\n}\n\n#typeMenu div {\n    padding: 0 3px;\n}\n\n#typeMenu div div {\n    margin: auto;\n    text-align: center;\n    cursor: pointer;\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n}\n\n.typeSelected {\n    border-bottom: 5px solid #007566\n}\n\n/* The container <div> - needed to position the dropdown content */\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    margin: 27px -11px;\n    border: 1px solid #EDF2F5;\n    background-color: white;\n    min-width: 160px;\n    z-index: 1;\n}\n\n/* Links inside the dropdown */\n.dropdown-content a {\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n/* Show the dropdown menu on hover */\n.dropdown:hover .dropdown-content {\n    display: block;\n}\n\n/* Change the background color of the dropdown button when the dropdown content is shown */\n.dropdown:hover .dropbtn {\n    background-color: #3e8e41;\n}\n\nngx-loading ::ng-deep div div.spinner-three-bounce {\n    position: fixed;\n    right: 21%;\n    z-index: 999;\n}\n\nng-sidebar-container ::ng-deep ng-sidebar ::ng-deep aside {\n    z-index: 130 !important;\n}\n\n// ng-sidebar-container ::ng-deep ng-sidebar ::ng-deep *,\n// ng-sidebar-container ::ng-deep *.ng-sidebar\n// {\n//     z-index: 130 !important;\n// }\n\nng-sidebar-container ::ng-deep ng-sidebar ::ng-deep #useMpoSatellite{\n    z-index: 0 !important;\n    position: relative;\n}\n\n::ng-deep .dropdown-menu {\n    min-width: 180px;\n}\n\n::ng-deep .dropdown-item {\n    display: block;\n    padding-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
